// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--69jGC","noBg":"Footer-module--noBg--KcfIc","corpTextColor":"Footer-module--corpTextColor--2Cjn_"};